import React, {forwardRef, useCallback} from 'react';
import CircularLoader from "./CircularLoader";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
// think about changing it over to an AntD button which handles more built in features of buttons
// import { Button as AntDButton } from 'antd';
export const BUTTON_SIZE = {
    SMALL:'small',
    MEDIUM:'medium'
}

export const BUTTON_TYPE = {
    TEXT:'text',
    TEXT_UNDERLINE:'text_underline',
    OUTLINE:'outline',
    SELECTOR:'selector'
}

export const BUTTON_ICON_POSITION = {
    LEFT: 'left',
    RIGHT: 'right'
}

const BUTTON_SIZE_CLASS = {
    [BUTTON_SIZE.SMALL]:'ch-btn-small',
    [BUTTON_SIZE.MEDIUM]:'ch-btn-medium'
}

const BUTTON_TYPE_CLASS = {
    [BUTTON_TYPE.TEXT]: 'ch-btn-text',
    [BUTTON_TYPE.OUTLINE]: 'ch-btn-outline',
    [BUTTON_TYPE.TEXT_UNDERLINE]: 'ch-btn-text ch-btn-text-underline',
    [BUTTON_TYPE.SELECTOR]: 'ch-btn-selector'
}

const Button = forwardRef((props, ref) => {
    const {type, className, size, icon, iconPosition = BUTTON_ICON_POSITION.LEFT, disabled, activated, loading = false, onClick, onFocus, onBlur, children, htmlType, ...other} = props;
    const extraProps = {};

    if (disabled || loading) {
        extraProps.disabled = 'disabled';
        extraProps['aria-disabled'] = 'true';
    }

    if (activated != undefined) {
        extraProps["aria-pressed"] = activated;
    }

    const handleClick = (event) => {
        if (loading || disabled) {
            event.preventDefault();
            return;
        }
        if (onClick) {
            onClick(event);
        }
    };

    const getLoader = useCallback(() => {
        return loading ? <Spin style={{paddingLeft:(iconPosition === BUTTON_ICON_POSITION.RIGHT ?'6px':'4px'),
        paddingRight:(iconPosition === BUTTON_ICON_POSITION.LEFT ?'6px':'4px')}} size="small" /> : icon;
    }, [loading]);

    return (
        <button
            ref={ref}
            className={'ch-button ch-btn' +
                (type ? ' '+BUTTON_TYPE_CLASS[type]:'') +
                (size ? ' '+BUTTON_SIZE_CLASS[size] : '') +
                (icon ? ' ch-button-icon-' + (iconPosition === BUTTON_ICON_POSITION.LEFT ? 'l' : 'r') : '') +
                (activated ? ' ch-activated' : '') +
                (disabled ? ' ch-button-disabled' : '') +
                (className ? ' ' + className : '')}
            {...extraProps}
            {...other}
            type={disabled || loading ? "button" : htmlType}
            onClick={handleClick}
            onBlur={onBlur}
            onFocus={onFocus}
        >
            <>
                {icon && iconPosition === BUTTON_ICON_POSITION.LEFT && (
                    <>{loading ? getLoader() : icon}</>
                )}
                {children}
                {icon && iconPosition === BUTTON_ICON_POSITION.RIGHT && (
                    <>{loading ? getLoader() : icon}</>
                )}
            </>
        </button>
    );
});

export default Button;